<template>
    <tr>
        <td><b class="font-weight-bold">{{new Date(item.date).toLocaleDateString("en-IN")}}</b></td>
        <td><b class="font-weight-bold" v-if="item.buyerId">{{buyerById(item.buyerId)['name']}} </b></td>
        <template>    
        <td> <b class="green--text font-weight-bold"> {{getCredit(item) || 0 | amount}} </b></td>        
        <td> <b class="red--text font-weight-bold"> {{getDebit(item)|| 0 | amount }} </b></td>
        </template>
        <td><b class="font-weight-bold">{{getVocherType(item)}} </b></td>
        <td><b class="font-weight-bold">{{item.paymentType}}</b></td>
        <td><b class="font-weight-bold">{{item.status}}</b></td>
        <td ><b class="font-weight-bold"> {{item.remark}} </b></td>
    </tr>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
const mapBuyerGetters = createNamespacedHelpers('Buyer')['mapGetters']

import {DateTime, Interval} from 'luxon'

    export default {
        props:{
            item:{
                type:Object,
                default: () => {
                    return {}
                }
            },
            isCredited: {
                type: Boolean,
                default: true
            }, 
            firms: {
                type: Array,
                default: []
            },  
            sellers: {
            type: Object,
                default: []
            },
            buyers: {
                type: Object,
                default: []
            },
            status: {
                type: Array,
                default: () => {
                    return ['close']
                }
            },
            firmAssignment: {
                type: Boolean,
                default: false
            },
            heading: {
                type: String,
                default: ""
            },
            selectedFirm: {
                type: String,
                default: null
            },
            selectedDate: {
                type: String,
                default: () => {
                let today = new Date()
                return `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}` 
                }
            }
        },
        data: () => ({
        }),
        computed:{
            ...mapGlobalGetters(['selectedBrand']),
            firmsByBrand () {
            return this.firms.filter((item) => 
                item['brand'] === this.selectedBrand
            )
        }
        },
        methods: {
            buyerById (id) {
                if (this.buyers[id]) {
                    return this.buyers[id]
                } else if (this.sellers[id]) {
                    return this.sellers[id]
                } else {
                    return {
                        name : '--'
                    }
                }
            },
            getCredit(item){
                if(item.isBuyer) {
                    switch(item.status) {
                        case 'due' : {
                            return item.totalAmount || item.amount || 0;
                            break;
                        }
                        case 'paid' : {
                            return 0;
                            break;
                        }
                        case 'partial' : {
                            return 0;
                            break;
                        }
                    }
                } else {
                     switch(item.status) {
                        case 'due' : {
                            return  item.settledAmount || 0
                            break;
                        }
                        case 'paid' : {
                            return (Number.parseFloat(item['amountFromBank']) + Number.parseFloat(item['amountFromCash']));
                            break;
                        }
                        case 'partial' : {
                            return (Number.parseFloat(item['amountFromBank']) + Number.parseFloat(item['amountFromCash']));
                            break;
                        }
                    }
                }
            },
            getDebit(item){
                if(item.isBuyer) {
                    switch(item.status) {
                        case 'due' : {
                            return item.settledAmount || 0;
                            break;
                        }
                        case 'paid' : {
                            return (Number.parseFloat(item['amountFromBank']) + Number.parseFloat(item['amountFromCash']));
                            break;
                        }
                        case 'partial' : {
                            return (Number.parseFloat(item['amountFromBank']) + Number.parseFloat(item['amountFromCash']));
                            break;
                        }
                    }
                } else {
                     switch(item.status) {
                        case 'due' : {
                            return item.totalAmount || item.amount || 0
                            break;
                        }
                        case 'paid' : {
                            return 0;
                            break;
                        }
                        case 'partial' : {
                            return 0;
                            break;
                        }
                    }
                }
            },
            firmNameById (id) {
                let firm = this.firms.filter(item=> item['.key'] == id)[0]
                if (firm) {
                    return firm['name']
                }
            },
            getNumberOfDaysFromStartDate (createdAt, closedDate) {
                console.log (createdAt, closedDate)
                const startDate = DateTime.fromMillis(createdAt)
                if(!closedDate) {
                    closedDate = DateTime.local()
                } else {
                    closedDate = DateTime.fromMillis(closedDate)
                }
                const endDate = closedDate
                const interval = Interval.fromDateTimes(startDate, endDate)
                return Number.parseInt(interval.length('days'))
            },
            getTotalAmount (principal, rate, createdAt) {
                const time = this.getNumberOfDaysFromStartDate(createdAt) / 365
                rate = rate * 12 / 100
                return Number.parseFloat(principal * (1 + (rate * time))).toFixed(2)
            },
            getInterestValue (principal, rate, createdAt) {
                return (this.getTotalAmount(principal, rate, createdAt) - Number.parseFloat(principal)).toFixed(2)
            },
            getVocherType(invoice) {
            if (invoice.return) {
                if (invoice.isBuyer) {
                return "Credit Note";
                } else {
                return "Debit Note";
                }
            }
            // if (invoice.isBuyer && invoice.transactionType === "Debit") {
            //     return "Sale";
            // } 
            // else if (invoice.isBuyer && invoice.transactionType === "Credit") {
            //     return "Receipt";
            // }
            // else if (invoice.isBuyer && invoice.transactionType === "Partial Paid") {
            //     return "Receipt";
            // }
            // else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
            //     return "Purchase";
            // }
            // else if (!invoice.isBuyer && invoice.transactionType === "Credit") {
            //     return "Payment";
            // }
            // else if (!invoice.isBuyer && invoice.transactionType === "Partial Paid") {
            //     return "Payment";
            // }
            if (invoice.isBuyer) {
                return "Sale";
            } else {
                return "Purchase";
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/SalePurchaseStatements/StatementView.vue